







import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class BmnCheckbox extends Vue {

  @Prop()
  public label: string;

  @Prop()
  public checked: boolean;

  @Prop()
  public isDisabled: boolean;

  public data() {
    return {
      checkedModel: this.checked
    };
  }

  public valueChanges(event: any): void {
    const name = this.mapName(event.target.name);
    const cbData = {
      checked: event.target.checked,
      name
    };
    this.$emit('checked', cbData);
  }

  private mapName(name: string): string {
    switch (name) {
      case 'SmartwayZ.NL':
        return 'Bereikbaarheidsakkoord';
        break;
      case 'Snelfietsroutes':
        return 'Routes';
        break;
      case 'A2 Deil-Vught':
        return 'Mirt';
        break;
      default:
        return name;
    }
  }
}
